import React from "react";
import { useApp } from "../../contexts";

export const ItemReady = ({ value, ...props }) => {
  const { T } = useApp();
  const { isLoading, className, title, description, actionBtn, actionBtnRight, isShowBtn } = props; 

  return (
    <div className={`w-full ${className}`}>
        <div
            className="drop-shadow"
            dangerouslySetInnerHTML={{
            __html: T(title),
            }}
        ></div>
        <div className={`w-full text-white leading-[26px] text-[14px] lg:text-[16px] item-desrciption`}>
            {T(description)}
        </div>
        <div className={`grid grid-cols-2 gap-2 lg:gap-6 lg:mt-[20px] xl:mt-[30px] sm:mt-[15px] xs:mt-2 lis-action-ready drop-shadow`}>
            <button className="explore-earner-btn" onClick={actionBtn}>
                {T('Explore your Art')}
            </button>
            {isShowBtn && <button className="earn-big-btn" onClick={actionBtnRight} disabled={isLoading}>
                {T('Create Wallet')}
            </button>}
        </div>
    </div>
  );
};
